export type Duration = {
  seconds: number
}

export const Duration = {
  minutes: (minutes: number): Duration => ({ seconds: minutes * 60 }),
  hours: (hours: number): Duration => ({ seconds: hours * 3600 }),
}

export const durationToHours = (duration: Duration): number =>
  Math.floor(Math.max(0, duration.seconds) / 3600)

export const durationToMinutes = (duration: Duration): number =>
  Math.floor((Math.max(0, duration.seconds) % 3600) / 60)

export const durationToHmm = (duration: Duration): string =>
  `${durationToHours(duration)}:${String(durationToMinutes(duration)).padStart(2, "0")}`

export const stepMinuteWithRollover = (
  duration: Duration,
  step: number,
  direction: 1 | -1
): Duration => {
  const totalMinutes = Math.floor(Math.max(0, duration.seconds) / 60)
  const hourPart = Math.floor(totalMinutes / 60)
  const minutePart = totalMinutes % 60

  const next =
    direction > 0
      ? Math.floor(minutePart / step) * step + step
      : Math.ceil(minutePart / step) * step - step

  if (next >= 60) {
    return { seconds: ((hourPart + 1) * 60 + (next - 60)) * 60 }
  }
  if (next < 0) {
    if (hourPart === 0) {
      return { seconds: 0 }
    }
    return { seconds: ((hourPart - 1) * 60 + (60 + next)) * 60 }
  }
  return { seconds: (hourPart * 60 + next) * 60 }
}

export const incrementToHourStep = (incrementSeconds: number): number =>
  Math.floor(incrementSeconds / 3600)

export const incrementToMinuteStep = (incrementSeconds: number): number =>
  Math.floor((incrementSeconds % 3600) / 60)
